import React, { useLayoutEffect, useRef } from 'react'
import { TableV2 } from 'stylist'
import styled from '@emotion/styled'

const InnerCell = styled.div`
  overflow-wrap: break-word;
`

const resizeTBody = tBodyRef => {
  const node = tBodyRef.current
  if (node && node.getBoundingClientRect) {
    const dimensions = node.getBoundingClientRect()
    const windowHeight = window.innerHeight
    node.style.height = `${windowHeight - dimensions.top - 20}px`
  }
}

const SamplesTableBody = ({ rows, prepareRow, getTableBodyProps }) => {
  const tBodyRef = useRef(null)

  // Set table body height to remaining space of window to get scrolling working
  useLayoutEffect(() => {
    const handleResize = () => resizeTBody(tBodyRef)

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [tBodyRef.current, window.innerHeight])

  return (
    <TableV2.Body
      {...getTableBodyProps({
        style: {
          overflowY: 'scroll',
          display: 'block'
        },
        ref: tBodyRef
      })}
    >
      {rows.map(row => {
        prepareRow(row)
        return (
          <TableV2.Row {...row.getRowProps()}>
            {row.cells.map(cell => (
              <TableV2.Cell
                {...cell.getCellProps({
                  highlighted: cell.column.isSorted
                })}
              >
                <InnerCell>{cell.render('Cell')}</InnerCell>
              </TableV2.Cell>
            ))}
          </TableV2.Row>
        )
      })}
    </TableV2.Body>
  )
}

export default SamplesTableBody



// WEBPACK FOOTER //
// ./src/routes/admin/SamplesTableBody.js